<div
  class="mx-auto mt-10 flex w-full max-w-[856px] flex-col items-center rounded-md border border-border-3 bg-white px-24 py-14"
>
  <p class="my-4 text-xl leading-none">{{ 'onboarding.your-size-chart-is-ready' | translate }}</p>
  <p class="max-w-[548px] text-center text-[15px] leading-[24px] text-text-2">
    {{
      'onboarding.you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later'
        | translate
    }}
  </p>

  <div class="mt-10 flex w-full flex-col gap-10">
    <button
      class="flex items-center gap-6 rounded-md border border-border-3 px-4 py-6 text-left transition-all hover:border-primary"
      [ngClass]="{ 'border-primary': selectedMethod() === 1 }"
      (click)="selectedMethod.set(1)"
    >
      @if (selectedMethod() === 1) {
        <div class="size-6 shrink-0 rounded-full border-[6px] border-primary bg-white"></div>
      } @else {
        <div class="size-6 shrink-0 rounded-full bg-border-6"></div>
      }

      <div class="flex grow flex-col gap-2">
        <p class="text-lg leading-none">{{ 'onboarding.apply-this-chart-to-products-now' | translate }}</p>
        <p class="text-[15px] leading-[24px] text-text-2">
          {{ 'onboarding.choose-which-products-should-use-this-size-chart' | translate }}
        </p>
      </div>
    </button>

    <button
      class="flex items-center gap-6 rounded-md border border-border-3 px-4 py-6 text-left transition-all hover:border-primary"
      [ngClass]="{ 'border-primary': selectedMethod() === 0 }"
      (click)="selectedMethod.set(0)"
    >
      @if (selectedMethod() === 0) {
        <div class="size-6 shrink-0 rounded-full border-[6px] border-primary bg-white"></div>
      } @else {
        <div class="size-6 shrink-0 rounded-full bg-border-6"></div>
      }

      <div class="flex grow flex-col gap-2">
        <p class="text-lg leading-none">{{ 'onboarding.i-ll-do-this-later' | translate }}</p>
        <p class="text-[15px] leading-[24px] text-text-2">
          {{ 'onboarding.you-can-assign-or-change-matching-anytime-from-chart-settings' | translate }}
        </p>
      </div>
    </button>
  </div>

  <div class="mt-10 flex gap-6 self-start">
    <button mat-button (click)="onSkip()">
      {{ 'onboarding.skip-for-now' | translate }}
    </button>
    <button mat-flat-button (click)="onContinue()" [disabled]="continueDisabled()">
      {{ 'common.continue' | translate }}
    </button>
    <!-- <app-button class="!leading-none" mainClass="p-3 text-xs font-semibold" > -->
    <!-- </app-button> -->
    <!-- <app-button -->
    <!--   class="!leading-none" -->
    <!--   mainClass="p-3 text-xs font-semibold" -->
    <!--   [color]="ButtonColor.primary" -->
    <!---->
    <!-- > -->
    <!-- </app-button> -->
  </div>
</div>
